import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import MatrimonyPage from './components/MatrimonyPage';
import Sitemap from './components/Sitemap';
import './App.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />

        <Route
          path="delhi-matrimony"
          element={
            <MatrimonyPage
              city="Delhi"
              metaTitle="Delhi Matrimony - Find Your Perfect Match in Delhi | ForeverUnion"
              metaDescription="Join the most trusted Delhi Matrimony service. Browse thousands of verified profiles of brides and grooms in Delhi. Register for free!"
              content={
                <div>
                  <h2 className="text-3xl font-bold text-gray-800 mb-6">Welcome to Delhi Matrimony</h2>
                  <p className="mb-4">
                    Delhi, the heart of India, is a melting pot of cultures. Finding a partner in this vibrant city can be overwhelming,
                    but ForeverUnion simplifies it for you. We bring you the finest profiles from Delhi NCR, including Noida, Gurgaon, and Faridabad.
                  </p>
                  <p className="mb-4">
                    Whether you are looking for a Punjabi, Baniya, Brahmin, or Muslim match in Delhi, our extensive database caters to all communities.
                  </p>
                </div>
              }
            />
          }
        />

        <Route
          path="mumbai-matrimony"
          element={
            <MatrimonyPage
              city="Mumbai"
              metaTitle="Mumbai Matrimony - Best Matrimonial Site in Mumbai | ForeverUnion"
              metaDescription="Looking for a life partner in Mumbai? ForeverUnion is Mumbai's #1 Matrimony site. Search by caste, community, and profession. Sign up now!"
              content={
                <div>
                  <h2 className="text-3xl font-bold text-gray-800 mb-6">Welcome to Mumbai Matrimony</h2>
                  <p className="mb-4">
                    Mumbai, the city that never sleeps, is full of dreams and aspirations. Finding someone who shares your dreams is special.
                    ForeverUnion helps you connect with eligible singles in Mumbai, Navi Mumbai, and Thane.
                  </p>
                  <p className="mb-4">
                    Explore profiles from diverse communities like Marathi, Gujarati, Parsi, and Cosmopolitan Mumbai.
                    We ensure a safe and secure environment for your partner search.
                  </p>
                </div>
              }
            />
          }
        />

        <Route path="sitemap" element={<Sitemap />} />

        {/* Fallback route */}
        <Route path="*" element={<div className="p-10 text-center"><h1>404 - Page Not Found</h1></div>} />
      </Route>
    </Routes>
  );
}

export default App;
